import { api } from "../client";

const API_MODULE =
  process.env.REACT_APP_API_MODULE || "dynesourcerapi.author";

export async function borrowerSignIn({ email, password }) {
  const payload = {
    usr: email,
    pwd: password,
    email,
    password,
  };
  const res = await api.post(`/api/method/${API_MODULE}.login`, payload);

  return {
    data: res.data,
    headers: res.headers,
  };
}
